import React, { useEffect, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Image } from "antd";

const PreviewContainer = ({
    showCloseButton,
    item,
    index,
    onClose,
    isUrl = false,
    showPreview = false,
}) => {
    const [state, setState] = useState({ image: "" });
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };
    useEffect(() => {
        if (!isUrl) getBase64UrlOfImage();
        return () => {};
    }, [item]);

    const getBase64UrlOfImage = async () => {
        const result = await getBase64(item?.originFileObj);
        setState({ ...state, image: result });
    };

    return (
        <div className="image-preview-container" onClick={() => null}>
            {showCloseButton === true && (
                <div
                    className={`close-icon  ${
                        showPreview && `delete-image-icon`
                    }`}
                    onClick={(e) => {
                        e.stopPropagation();
                        onClose(item, index);
                    }}
                >
                    <CloseOutlined />
                </div>
            )}
            {showPreview ? (
                <Image
                    key={index}
                    preview={true}
                    src={isUrl ? item : state.image}
                />
            ) : (
                <img key={index} src={isUrl ? item : state.image} />
            )}
        </div>
    );
};

export default PreviewContainer;
